<template>
  <div :style="containerStyle" />
</template>

<script>
  import { Layout } from '@js/styles'

  export default {
    name: 'DummyItemCardPrimary',
    data: function () {
      return {
        containerStyle: {
          flex: 1,
          height: '0px',
          margin: '0 12px 0 12px',
          minWidth: '240px',
          padding: `0 ${Layout.space.md}`,
        },
      };
    },
  };
</script>
